/**
 * The rail's icon row (unit convention §1). Context-free: the navigation it
 * needs is `rail/navigateRef`, not `useNavigation`.
 */
import React from 'react';

import {useRailActionsModel} from './model';
import RailActionsView from './View';

export default React.memo(function RailActions() {
  return <RailActionsView {...useRailActionsModel()} />;
});
